
































































import LatestEntriesCardEmpty from "@/components/cards/LatestEntriesCardEmpty.vue";
import Debug from "@/components/utility/Debug.vue";
import ErrorCard from "@/components/utility/ErrorCard.vue";
import LayoutReportWithBanner from "@/layouts/LayoutReportWithBanner.vue";
import { formatHoursAndMinutes } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { BookingServiceBookingViewModelGen } from "@/services/booking/v1/data-contracts";
import { PartnerModule } from "@/store/modules/partner";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Vue } from "vue-property-decorator";
import { AvailabilityModule } from "@/store/modules/availability.store";

@Component({
  components: {
    LayoutReportWithBanner,
    LatestEntriesCardEmpty,
    Debug,
    ErrorCard
  },
  filters: {
    formatHoursAndMinutes
  }
})
export default class BookingServiceAvailability extends Vue {
  /**
   * Displays loading animation while async calls
   */
  isLoading = false;

  /**
   * The service selected by the user
   */
  selectedService: BookingServiceBookingViewModelGen | undefined = undefined;

  get headlineText(): string {
    return String(this.$i18n.t("report.booking.headline"));
  }

  get subHeadlineText(): string {
    return String(this.$i18n.t("report.booking.subHeadline"));
  }

  get headerImage() {
    if (PartnerModule?.partner?.settings?.reportSettings?.headerImageUrl) {
      return PartnerModule?.partner?.settings?.reportSettings?.headerImageUrl;
    } else if (PartnerModule?.partner?.settings?.headerImageUrl) {
      return PartnerModule?.partner?.settings?.headerImageUrl;
    } else {
      return "https://mmmint.azureedge.net/wirkaufendeinethg/header-image.png";
    }
  }

  get partnerId() {
    return this.partner._id;
  }

  get partner() {
    return ReportModule.partner;
  }

  get bookableServices(): BookingServiceBookingViewModelGen[] {
    return AvailabilityModule.paginationList;
  }

  async refresh() {
    this.isLoading = true;
    try {
      await AvailabilityModule.fetchAllFromBeginning({
        partnerId: this.partnerId
      });
    } catch (error) {
      handleError(error);
    } finally {
      this.isLoading = false;
    }
  }

  async mounted() {
    await this.refresh();
  }
}
